import React from 'react';
import { useAuth } from  '../../contexts/auth'; 

import { createStore } from 'devextreme-aspnet-data';
import {
    Chart, Series, Size, Label,CommonSeriesSettings, Legend, ValueAxis, Title, Export, Tooltip
} from 'devextreme-react/chart';

export default function CashFlow(props) {

    const { user } = useAuth(); 
    const projectId = props.projectId;
    const serviceUrl = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/Commessa'
    const filterPayload = { 
        commessa: projectId
    };

    var cashFlowUrl = "CashFlow";
    if (props.type ==='Actual') 
        cashFlowUrl ="CashFlowActual";
    else if (props.type ==='Original') 
        cashFlowUrl ="CashFlowOriginal";
      
    const remoteDataSource = createStore({
        key: 'id',
        //loadUrl: serviceUrl + '/CashFlow',
        loadUrl: serviceUrl + '/' + cashFlowUrl,
        onBeforeSend: (method, ajaxOptions) => {
          if (method === "load" ) {            
              var payload = ajaxOptions.data;
              payload.values = JSON.stringify(filterPayload);
              ajaxOptions.data = payload;          
              //console.log(ajaxOptions.data);
              //console.log('CommessaId:' + projectId);
          }        
          ajaxOptions.headers = { Authorization: `Bearer ${user.token}`}
        },    
    });

    function pointClickHandler(e) {
        this.toggleVisibility(e.target);
    }
    
    function legendClickHandler(e) {
        const arg = e.target;
        const item = e.component.getAllSeries()[0].getPointsByArg(arg)[0];
        toggleVisibility(item);
    }

    function toggleVisibility(item) {
        item.isVisible() ? item.hide() : item.show();
    }

    return (
        <div >
            <Chart
                id={`bar1-${cashFlowUrl}`}
                
                dataSource={remoteDataSource}
                palette="Bright"
                onPointClick={pointClickHandler}
                onLegendClick={legendClickHandler}
            >

            <CommonSeriesSettings
                argumentField="meseAnno"
                type="line"
                point={{ visible: false }}
                barPadding={0}  
            />
            <Title visible={false} />
            <Series
                valueField="entrate"
                name="entrate"
                type="bar"
                color="#4caf50"
            ></Series>
            <Series
                valueField="uscite"
                name="uscite"
                type="bar"
                color="#f44336"
            ></Series>
             <Series
                valueField="cassa"
                name="cassa"
                type="spline"
                color="#2196f3"
            ></Series>

            <Legend visible={true}/>
            
            <Export enabled={false} />
            <Tooltip
                enabled={true}
                location="edge" visible
                //customizeTooltip={customizeTooltip2}
            />
            </Chart>
        </div>
    )
};